import ShowcasePrivacyPolicyTypes from 'store/actionTypes/showcasePrivacyPolicy'

import UserTypes from 'store/actionTypes/user'

const initialData = {
  current: {}
}

const showcasePrivacyPolicy = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ShowcasePrivacyPolicyTypes.GET_SHOWCASE_PRIVACY_POLICY_SUCCESS:
      return {
        ...state,
        current: payload?.items.length > 0 ? payload?.items[0] : {}
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default showcasePrivacyPolicy
